export default {
    setAccount(state, account) {
        state.account = account;
    },
    setIsLoggedIn(state, isLoggedIn) {
        state.isLoggedIn = isLoggedIn
    }
}